import crypto from 'crypto';
import React from 'react';
import ReactDOM from 'react-dom';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

const rnds8Pool = new Uint8Array(256); // # of random values to pre-allocate

let poolPtr = rnds8Pool.length;
function rng() {
  if (poolPtr > rnds8Pool.length - 16) {
    crypto.randomFillSync(rnds8Pool);
    poolPtr = 0;
  }

  return rnds8Pool.slice(poolPtr, poolPtr += 16);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

var native = {
  randomUUID: crypto.randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

var ScannerContext = React.createContext({
  elements: {}
});

var checkVisible = function checkVisible(element) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'visible';

  var rect = element.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var above = rect.bottom - threshold < 0;
  var below = rect.top - viewHeight + threshold >= 0;

  var isVisible = !above && !below;
  if (mode === 'above') {
    isVisible = above;
  }

  if (mode === 'below') {
    isVisible = below;
  }

  return {
    isVisible: isVisible,
    above: above,
    below: below,
    rect: rect,
    viewHeight: viewHeight
  };
};

var checkVisibleAndScroll = function checkVisibleAndScroll(element) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'visible';

  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var fixedThreshold = viewHeight * threshold / 100;

  var _checkVisible = checkVisible(element, fixedThreshold, mode),
      isVisible = _checkVisible.isVisible,
      rect = _checkVisible.rect;

  var _window = window,
      scrollX = _window.scrollX,
      scrollY = _window.scrollY;


  if (!isVisible) {
    var elementPosY = scrollY + rect.top - fixedThreshold;
    window.scrollTo(scrollX, elementPosY);
    element.scrollIntoView();
  }
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Scannable = function (_React$Component) {
  inherits(Scannable, _React$Component);

  function Scannable(props) {
    classCallCheck(this, Scannable);

    var _this = possibleConstructorReturn(this, (Scannable.__proto__ || Object.getPrototypeOf(Scannable)).call(this, props));

    _this.scannableId = v4();
    _this.isFocused = false;
    return _this;
  }

  createClass(Scannable, [{
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.props.disabled;
    }
  }, {
    key: 'onSelect',
    value: function onSelect(event) {
      this.props.onSelect(event, this, this.props.scanner);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scanner = this.props.scanner;

      if (scanner && scanner.addScannableElement) {
        scanner.addScannableElement(this);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref) {
      var disabled = _ref.disabled;

      if (disabled !== this.props.disabled) {
        var scanner = this.props.scanner;

        scanner.updateScannableElement(this);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          scanner = _props.scanner,
          disabled = _props.disabled,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          other = objectWithoutProperties(_props, ['children', 'scanner', 'disabled', 'onFocus', 'onBlur']);
      var focusedItem = scanner.focusedItem,
          config = scanner.config;


      var childrenWithProps = children;

      if (config) {
        var focusedClassName = config.focusedClassName,
            focusedVisibleThreshold = config.focusedVisibleThreshold;

        childrenWithProps = React.Children.map(children, function (child) {
          var classes = [child.props.className || ''];
          var isFocused = focusedItem.element && focusedItem.element.scannableId === _this2.scannableId;
          var isBlurred = _this2.isFocused && !isFocused;
          _this2.isFocused = isFocused;

          if (isFocused) {
            classes.push(focusedClassName);
            checkVisibleAndScroll(focusedItem.node, focusedVisibleThreshold);
            onFocus(_this2, scanner);
          } else if (isBlurred) {
            onBlur(_this2, scanner);
          }

          var className = classes.join(' ').trim();
          return React.cloneElement(child, _extends({ className: className }, other));
        });
      }

      return React.createElement(
        React.Fragment,
        null,
        childrenWithProps
      );
    }
  }]);
  return Scannable;
}(React.Component);

Scannable.defaultProps = {
  disabled: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onSelect: function onSelect() {}
};

Scannable.propTypes = {
  children: propTypes.node.isRequired,
  scanner: propTypes.object.isRequired,
  disabled: propTypes.bool,
  onFocus: propTypes.func,
  onBlur: propTypes.func,
  onSelect: propTypes.func
};

var WithScanner = function WithScanner(Component) {
  return function (props) {
    return React.createElement(
      ScannerContext.Consumer,
      null,
      function (scannerContext) {
        return React.createElement(Component, _extends({}, props, { scanner: scannerContext }));
      }
    );
  };
};

var Scannable$1 = WithScanner(Scannable);

var SCANNER_STRATEGY = 'automatic';
var SCANNER_EVENTS = ['click', 'keydown', 'contextmenu'];
var SCANNER_CLASSNAME = 'Scanner__Container';
var SCANNER_SELECT_DEBOUNCE_TIME = 400;
var SCANNER_SELECT_KEYCODES = ['enter', 'backspace', 13, 8];
var SCANNER_AUTODEACTIVATE_KEYCODES = ['scape', 27];
var SCANNER_AUTODEACTIVATE_COUNT = 4;
var SCANNER_ADVANCE_KEYCODES = ['*', 'spacebar', 'tab', 'rightArrow', 'downArrow', 32, 9];
var SCANNER_SELECT_CLICKEVENT = 'contextmenu';
var SCANNER_ADVANCE_CLICKEVENT = 'click';
var SCANNER_MOVE_BACK_KEYS = ['leftArrow', 'upArrow'];
var SCANNER_CLASSNAME_ACTIVE = 'Scanner__Container Scanner__Container--active';
var SCANNER_ITERATION_INTERVAL = 2000;
var SCANNABLE_FOCUSED_CLASSNAME = 'scanner__focused';
var SCANNABLE_FOCUSED_VISIBLE_THRESHOLD = 5;

var KEY_CODE_MAP = {
  enter: 13,
  backspace: 8,
  spacebar: 32,
  tab: 9,
  shift: 16,
  control: 17,
  alt: 18,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  escape: 27
};

// https://gist.github.com/nmsdvid/8807205#gistcomment-2595895
// const debounce = (callback, time = 250, debounceInterval) => (...args) =>
//   clearTimeout(debounceInterval, (debounceInterval = setTimeout(() => callback(...args), time)));

var debounce = function debounce(callback) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (immediate && !timeout) {
      callback.apply(undefined, args);
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) {
        callback.apply(undefined, args);
      }
    }, time);
  };
};

var dispatchEvent = function dispatchEvent(element, event) {
  var node = element.node;

  var eventToDispatch = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false
  });

  node.dispatchEvent(eventToDispatch);
};

var configKeys = ['advanceClickEvent', 'advanceKeyCodes', 'moveBackKeyCodes', 'autoDeactivateCount', 'autoDeactivateKeyCodes', 'className', 'classNameActive', 'events', 'iterationInterval', 'focusedClassName', 'focusedVisibleThreshold', 'selectClickEvent', 'selectDebounceTime', 'selectKeyCodes', 'strategy', 'target'];

var getConfig = function getConfig(props) {
  var config = {};
  var propsKeys = Object.keys(props).filter(function (k) {
    return configKeys.indexOf(k) >= 0;
  });

  propsKeys.forEach(function (k) {
    config[k] = props[k];
  });

  return config;
};

var BaseStrategy = function () {
  function BaseStrategy(scanner) {
    classCallCheck(this, BaseStrategy);

    this.scanner = scanner;
    this.config = scanner.config;
  }

  createClass(BaseStrategy, [{
    key: 'activate',
    value: function activate() {
      console.log('Scanner should be activated');
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      console.log('Scanner should be deactivated');
    }
  }, {
    key: 'checkAutoDeactivation',
    value: function checkAutoDeactivation(event) {
      console.log('Strategy should provide a checkAutoDeactivation function');
    }
  }, {
    key: 'getNextScannableId',
    value: function getNextScannableId() {
      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scanner.state.focusedId;
      var keysToIterate = this.scanner.state.keysToIterate;

      var nextFocusedIndex = keysToIterate.indexOf(focusedId) + 1;

      return nextFocusedIndex < keysToIterate.length ? keysToIterate[nextFocusedIndex] : keysToIterate[0];
    }
  }, {
    key: 'getPrevScannableId',
    value: function getPrevScannableId() {
      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scanner.state.focusedId;
      var keysToIterate = this.scanner.state.keysToIterate;

      var nextFocusedIndex = keysToIterate.indexOf(focusedId) - 1;

      return nextFocusedIndex >= 0 ? keysToIterate[nextFocusedIndex] : keysToIterate[keysToIterate.length - 1];
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(scannable, event) {
      this.scanner.setSelectedElement(scannable, event);
      utils.dispatchEvent(scannable, event);
      scannable.element.onSelect(event);
    }
  }, {
    key: 'selectElement',
    value: function selectElement(scannable, event) {
      var selectedPath = [];
      if (scannable && scannable.treeId) {
        if (scannable.children) {
          selectedPath = this.scanner.state.selectedPath.concat(scannable.treeId);
        } else {
          this.dispatchEvent(scannable, event);
        }
      }

      this.scanner.setSelectedPath(selectedPath);
    }
  }]);
  return BaseStrategy;
}();

var AutomaticStrategy = function (_BaseStrategy) {
  inherits(AutomaticStrategy, _BaseStrategy);

  function AutomaticStrategy(scanner) {
    classCallCheck(this, AutomaticStrategy);

    var _this = possibleConstructorReturn(this, (AutomaticStrategy.__proto__ || Object.getPrototypeOf(AutomaticStrategy)).call(this, scanner));

    _this.autoDeactivationCounter = 0;
    _this.autoDeactivationToutFn = null;
    _this.autoDeactivationKeyCodes = new Set(scanner.config.autoDeactivateKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    return _this;
  }

  createClass(AutomaticStrategy, [{
    key: 'activate',
    value: function activate() {
      var _this2 = this;

      this.clearIterateInterval();

      if (this.scanner.state.keysToIterate.length) {
        this.iterateIntervalFn = setInterval(function () {
          var newFocusedId = _this2.getNextScannableId();
          _this2.scanner.focusScannable(newFocusedId);
        }, this.config.iterationInterval);
      }
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.clearIterateInterval();
    }
  }, {
    key: 'checkAutoDeactivation',
    value: function checkAutoDeactivation(event) {
      var _this3 = this;

      var eventType = event.type,
          keyCode = event.keyCode;

      if (eventType === 'keydown') {
        if (this.autoDeactivationKeyCodes.has(keyCode)) {
          if (this.autoDeactivationToutFn) {
            clearTimeout(this.autoDeactivationToutFn);
          }

          this.autoDeactivationCounter = this.autoDeactivationCounter + 1;
          if (this.autoDeactivationCounter >= this.scanner.config.autoDeactivateCount) {
            this.deactivate();
            this.scanner.triggerDeactivation();
            this.autoDeactivationCounter = 0;
          } else {
            this.autoDeactivationToutFn = setTimeout(function () {
              _this3.autoDeactivationCounter = 0;
            }, 600);
          }

          return false;
        }
      }

      return true;
    }
  }, {
    key: 'clearIterateInterval',
    value: function clearIterateInterval() {
      if (this.iterateIntervalFn) {
        clearInterval(this.iterateIntervalFn);
      }
    }
  }]);
  return AutomaticStrategy;
}(BaseStrategy);

var ManualStrategy = function (_BaseStrategy) {
  inherits(ManualStrategy, _BaseStrategy);

  function ManualStrategy(scanner) {
    classCallCheck(this, ManualStrategy);

    var _this = possibleConstructorReturn(this, (ManualStrategy.__proto__ || Object.getPrototypeOf(ManualStrategy)).call(this, scanner));

    var _scanner$config = scanner.config,
        selectClickEvent = _scanner$config.selectClickEvent,
        advanceClickEvent = _scanner$config.advanceClickEvent,
        moveBackKeyCodes = _scanner$config.moveBackKeyCodes,
        selectKeyCodes = _scanner$config.selectKeyCodes,
        advanceKeyCodes = _scanner$config.advanceKeyCodes,
        autoDeactivateKeyCodes = _scanner$config.autoDeactivateKeyCodes;

    _this.selectClickEvent = selectClickEvent;
    _this.advanceClickEvent = advanceClickEvent;
    _this.selectKeyCodes = new Set(selectKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    _this.advanceKeyCodes = new Set(advanceKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    _this.moveBackKeyCodes = new Set(moveBackKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));

    _this.autoDeactivationCounter = 0;
    _this.autoDeactivationToutFn = null;
    _this.autoDeactivationKeyCodes = new Set(autoDeactivateKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));

    _this.isActive = false;
    return _this;
  }

  createClass(ManualStrategy, [{
    key: 'activate',
    value: function activate() {
      this.isActive = true;
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.isActive = false;
    }
  }, {
    key: 'checkAutoDeactivation',
    value: function checkAutoDeactivation(event) {
      var _this2 = this;

      var eventType = event.type,
          keyCode = event.keyCode;

      if (eventType === 'keydown') {
        if (this.autoDeactivationKeyCodes.has(keyCode)) {
          if (this.autoDeactivationToutFn) {
            clearTimeout(this.autoDeactivationToutFn);
          }

          this.autoDeactivationCounter = this.autoDeactivationCounter + 1;
          if (this.autoDeactivationCounter >= this.scanner.config.autoDeactivateCount) {
            this.deactivate();
            this.scanner.triggerDeactivation();
            this.autoDeactivationCounter = 0;
          } else {
            this.autoDeactivationToutFn = setTimeout(function () {
              _this2.autoDeactivationCounter = 0;
            }, 600);
          }

          return false;
        }
      }

      return true;
    }
  }, {
    key: 'selectElement',
    value: function selectElement(scannable, event) {
      var eventType = event.type,
          keyCode = event.keyCode;

      var reverse = this.moveBackKeyCodes.has(keyCode);

      switch (eventType) {
        case 'keydown':
          if (this.selectKeyCodes.has(keyCode)) {
            this.select(scannable, event);
          } else if (reverse || this.advanceKeyCodes.has(keyCode) || this.advanceKeyCodes.has('*')) {
            this.advance(scannable, event, reverse);
          }
          break;

        case this.selectClickEvent:
          this.select(scannable, event);
          break;

        case this.advanceClickEvent:
          this.advance(scannable, event);
          break;

        default:
          break;
      }
    }
  }, {
    key: 'advance',
    value: function advance(scannable, event) {
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var action = reverse ? 'getPrevScannableId' : 'getNextScannableId';
      var newFocusedId = this[action]();
      this.scanner.focusScannable(newFocusedId);
    }
  }, {
    key: 'select',
    value: function select(scannable, event) {
      var selectedPath = [];
      if (scannable && scannable.treeId) {
        if (scannable.children) {
          selectedPath = this.scanner.state.selectedPath.concat(scannable.treeId);
        } else {
          this.dispatchEvent(scannable, event);
        }
      }

      this.scanner.setSelectedPath(selectedPath);
    }
  }]);
  return ManualStrategy;
}(BaseStrategy);

var Strategies = {
  automatic: AutomaticStrategy,
  manual: ManualStrategy
};

var getStrategy = function getStrategy(strategyName, scanner) {
  var StrategyConstructor = Strategies[strategyName] || Strategies.automatic;
  return new StrategyConstructor(scanner);
};

var getScannableChildrenOfElement = function getScannableChildrenOfElement(element, scannables) {
  var scannableNodes = scannables.map(function (_ref) {
    var node = _ref.node;
    return node;
  });
  var elementChildren = Array.from(element.children || []);
  var scannableChildren = [];

  if (elementChildren.length) {
    elementChildren.forEach(function (child) {
      var index = scannableNodes.indexOf(child);
      if (index >= 0) {
        var scannableChild = scannables[index];
        scannableChildren.push(scannableChild);
      } else if (child.children && child.children.length) {
        scannableChildren = scannableChildren.concat(getScannableChildrenOfElement(child, scannables));
      }
    });
  }

  return scannableChildren;
};

var getTreeForElement = function getTreeForElement(elementNode, scannables) {
  var scannableChildren = getScannableChildrenOfElement(elementNode, scannables);

  var newScannables = scannables.filter(function (e) {
    return scannableChildren.indexOf(e) < 0;
  });
  scannableChildren.forEach(function (sc) {
    if (sc.node.children && sc.node.children.length) {
      sc.children = getTreeForElement(sc.node, newScannables);
    }
  });

  var tree = scannableChildren.reduce(function (prev, sc, i) {
    var treeId = i + "_" + sc.element.scannableId;
    prev[treeId] = _extends({}, sc, { treeId: treeId });

    if (sc.children && Object.keys(sc.children).length === 0) {
      delete prev[treeId].children;
    }

    return prev;
  }, {});

  return tree;
};

var utils = {
  checkVisible: checkVisible,
  checkVisibleAndScroll: checkVisibleAndScroll,
  debounce: debounce,
  dispatchEvent: dispatchEvent,
  getConfig: getConfig,
  getStrategy: getStrategy,
  getTreeForElement: getTreeForElement
};

// https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js
var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var concat = Function.bind.call(Function.call, Array.prototype.concat);
var keys = Reflect.ownKeys;

if (!Object.values) {
  Object.values = function values(O) {
    return reduce(keys(O), function (v, k) {
      return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []);
    }, []);
  };
}

if (!Object.entries) {
  Object.entries = function entries(O) {
    return reduce(keys(O), function (e, k) {
      return concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []);
    }, []);
  };
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".Scanner__Container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n}\n\n.Scanner__EventsHandler {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.scanner__focused {\n  outline: 4px solid rgba(255, 0, 0, 1);\n  outline-offset: -4px;\n}\n";
styleInject(css);

var getConfig$1 = utils.getConfig,
    getStrategy$1 = utils.getStrategy,
    getTreeForElement$1 = utils.getTreeForElement,
    debounce$1 = utils.debounce;


var SCANNER_INITIAL_STATE = {
  selectedPath: [],
  elementsToIterate: {},
  keysToIterate: [],
  focusedId: 'not-valid-id'
};

var Scanner = function (_React$Component) {
  inherits(Scanner, _React$Component);

  function Scanner(props) {
    classCallCheck(this, Scanner);

    var _this = possibleConstructorReturn(this, (Scanner.__proto__ || Object.getPrototypeOf(Scanner)).call(this, props));

    _this.scannerEventAction = function (event) {
      var active = _this.props.active;


      var shouldContinue = true;
      if (_this.config.autoDeactivateCount) {
        shouldContinue = _this.strategy.checkAutoDeactivation(event);
      }

      if (!shouldContinue) {
        _this.props.onAutoDeactivateAction(event);
      }

      if (active && shouldContinue && !_this.selectedElement) {
        event.preventDefault();
        event.stopPropagation();

        var elementToSelect = _this.state.elementsToIterate[_this.state.focusedId];
        if (elementToSelect) {
          _this.debouncedSelectElement(elementToSelect, event);
        }
      }
    };

    _this.addScannableElement = function (element) {
      _this.elements[element.scannableId] = {
        element: element,
        node: ReactDOM.findDOMNode(element)
      };

      if (_this.props.active) {
        _this.findNodes();
      }
    };

    _this.updateScannableElement = function (element) {
      _this.elements[element.scannableId] = {
        element: element,
        node: ReactDOM.findDOMNode(element)
      };

      var focusedId = _this.state.focusedId;
      if (element.scannableId === focusedId) {
        focusedId = _this.strategy.getNextScannableId(focusedId);
      }

      _this.findNodes();
      _this.iterateScannableElements(focusedId);
    };

    _this.onScannableFocus = function () {
      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.focusedId;

      var _ref = _this.state.elementsToIterate[focusedId] || {},
          element = _ref.element;

      if (element) {
        _this.props.onFocus(element, _this);
      }
    };

    _this.reset = function () {
      _this.strategy.deactivate();
      _this.findNodes();
      _this.setState(SCANNER_INITIAL_STATE, _this.iterateScannableElements);
    };

    _this.state = SCANNER_INITIAL_STATE;
    _this.scannerNode = null;
    _this.elements = {};
    _this.tree = {};
    _this.selectedElement = null;
    _this.config = getConfig$1(props);
    _this.strategy = getStrategy$1(_this.config.strategy, _this);
    _this.debouncedSelectElement = debounce$1(function (element, event) {
      _this.selectElement(element, event);
    }, _this.config.selectDebounceTime);

    _this.target = _this.config.target;
    return _this;
  }

  createClass(Scanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.registerEvents();

      if (this.props.active) {
        this.findNodes();
        this.iterateScannableElements();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregisterEvents();
      this.strategy.deactivate();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.active !== this.props.active) {
        if (this.props.active) {
          this.findNodes();
          this.iterateScannableElements();
        } else {
          this.strategy.deactivate();
          this.setState(SCANNER_INITIAL_STATE);
        }
      }

      var newConfig = getConfig$1(this.props);
      if (newConfig.strategy !== this.config.strategy) {
        this.strategy.deactivate();
        this.strategy = getStrategy$1(newConfig.strategy, this);
      }

      this.config = newConfig;
      this.debouncedSelectElement = debounce$1(function (element, event) {
        _this2.selectElement(element, event);
      }, this.config.selectDebounceTime);
    }
  }, {
    key: 'triggerDeactivation',
    value: function triggerDeactivation() {
      this.props.onDeactivation();
      this.setState(SCANNER_INITIAL_STATE);
    }
  }, {
    key: 'findNodes',
    value: function findNodes() {
      this.scannerNode = ReactDOM.findDOMNode(this);
      var elementsArray = Object.values(this.elements);
      var children = getTreeForElement$1(this.scannerNode, elementsArray);
      this.tree = { children: children };
    }
  }, {
    key: 'getElementsToIterate',
    value: function getElementsToIterate() {
      var active = this.props.active;

      var elementsToIterate = {};
      var keysToIterate = [];
      if (!active) {
        return {
          elementsToIterate: elementsToIterate,
          keysToIterate: keysToIterate
        };
      }

      var current = this.tree;
      if (this.state.selectedPath.length) {
        current = this.state.selectedPath.reduce(function (prev, id) {
          prev = prev.children[id];
          return prev;
        }, current);
      }

      if (!current || !current.children) {
        current = {};
      }

      elementsToIterate = current.children || {};
      keysToIterate = Object.keys(elementsToIterate).filter(function (k) {
        return elementsToIterate[k].element.isEnabled();
      });

      return {
        elementsToIterate: elementsToIterate,
        keysToIterate: keysToIterate
      };
    }
  }, {
    key: 'selectElement',
    value: function selectElement(scannable, event) {
      if (scannable && scannable.treeId) {
        this.strategy.selectElement(scannable, event);
      }
    }
  }, {
    key: 'setSelectedElement',
    value: function setSelectedElement(scannable, event) {
      this.selectedElement = scannable;

      this.props.onSelect(event, scannable, this);
    }
  }, {
    key: 'setSelectedPath',
    value: function setSelectedPath() {
      var selectedPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedPath;

      this.setState({ selectedPath: selectedPath }, this.iterateScannableElements);
    }
  }, {
    key: 'focusScannable',
    value: function focusScannable(focusedId) {
      this.setState({ focusedId: focusedId }, this.onScannableFocus);
    }
  }, {
    key: 'iterateScannableElements',
    value: function iterateScannableElements() {
      var _this3 = this;

      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.focusedId;

      this.selectedElement = null;

      var _getElementsToIterate = this.getElementsToIterate(),
          elementsToIterate = _getElementsToIterate.elementsToIterate,
          keysToIterate = _getElementsToIterate.keysToIterate;

      var newFocusedId = elementsToIterate[focusedId] ? focusedId : keysToIterate[0];

      this.setState({
        elementsToIterate: elementsToIterate,
        keysToIterate: keysToIterate,
        focusedId: newFocusedId
      }, function () {
        _this3.onScannableFocus(newFocusedId);
        _this3.strategy.activate();
      });
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents() {
      var _this4 = this;

      this.config.events.forEach(function (e) {
        return _this4.target.addEventListener(e, _this4.scannerEventAction);
      });
    }
  }, {
    key: 'unregisterEvents',
    value: function unregisterEvents() {
      var _this5 = this;

      this.config.events.forEach(function (e) {
        return _this5.target.removeEventListener(e, _this5.scannerEventAction);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          active = _props.active;

      var focusedItem = this.state.keysToIterate.length > 0 ? this.state.elementsToIterate[this.state.focusedId] : {};

      var contextValue = _extends({}, this.state, {
        config: this.config,
        focusedItem: focusedItem,
        addScannableElement: this.addScannableElement,
        updateScannableElement: this.updateScannableElement,
        reset: this.reset
      });

      var classes = active ? this.config.classNameActive : this.config.className;

      return React.createElement(
        ScannerContext.Provider,
        { value: contextValue },
        React.createElement(
          'div',
          { className: classes },
          children
        )
      );
    }
  }]);
  return Scanner;
}(React.Component);

Scanner.defaultProps = {
  active: false,
  autoDeactivateCount: SCANNER_AUTODEACTIVATE_COUNT,
  autoDeactivateKeyCodes: SCANNER_AUTODEACTIVATE_KEYCODES,
  advanceKeyCodes: SCANNER_ADVANCE_KEYCODES,
  advanceClickEvent: SCANNER_ADVANCE_CLICKEVENT,
  moveBackKeyCodes: SCANNER_MOVE_BACK_KEYS,
  className: SCANNER_CLASSNAME,
  classNameActive: SCANNER_CLASSNAME_ACTIVE,
  events: SCANNER_EVENTS,
  focusedClassName: SCANNABLE_FOCUSED_CLASSNAME,
  focusedVisibleThreshold: SCANNABLE_FOCUSED_VISIBLE_THRESHOLD,
  iterationInterval: SCANNER_ITERATION_INTERVAL,
  onSelect: function onSelect() {},
  onFocus: function onFocus() {},
  onAutoDeactivateAction: function onAutoDeactivateAction() {},
  onDeactivation: function onDeactivation() {},
  selectClickEvent: SCANNER_SELECT_CLICKEVENT,
  selectDebounceTime: SCANNER_SELECT_DEBOUNCE_TIME,
  selectKeyCodes: SCANNER_SELECT_KEYCODES,
  strategy: SCANNER_STRATEGY,
  target: document.body
};

Scanner.propTypes = {
  active: propTypes.bool,
  autoDeactivateCount: propTypes.number,
  autoDeactivateKeyCodes: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.number])),
  advanceKeyCodes: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.number])),
  advanceClickEvent: propTypes.string,
  moveBackKeyCodes: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.number])),
  children: propTypes.node.isRequired,
  className: propTypes.string,
  classNameActive: propTypes.string,
  events: propTypes.arrayOf(propTypes.string),
  focusedClassName: propTypes.string,
  focusedVisibleThreshold: propTypes.number,
  iterationInterval: propTypes.number,
  onSelect: propTypes.func,
  onFocus: propTypes.func,
  onAutoDeactivateAction: propTypes.func,
  onDeactivation: propTypes.func,
  selectClickEvent: propTypes.string,
  selectDebounceTime: propTypes.number,
  selectKeyCodes: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.number])),
  strategy: propTypes.string,
  target: propTypes.instanceOf(Element)
};

export { Scannable$1 as Scannable, Scanner };
